import type { TranslationSchema } from './en'

export const zh: TranslationSchema = {
  game: {
    title: 'Path of Praxis',
    subtitle: '打造你的放置自动战斗游戏理论',
    deathTitle: '你已死亡',
    deathSubtitle: '你获得了以下经验和精通，让你的下次重生更加强大：',
    deathRebirth: '重生',
    actionSelectTitle: '行动',
    triggersTitle: '行动触发器',
    triggerAutoAction: '自动攻击',
    actionPickerTitle: '选择行动',
    legendDamage: '伤害',
    legendSpeed: '速度',
    legendRange: '范围',
    legendArea: '区域',
    legendMana: '法力',
    targetingTitle: '目标优先级',
    targetNearest: '最近',
    targetWeakest: '最弱',
    targetStrongest: '最强',
    targetRandom: '随机',
    targetNearestDesc: '攻击最近的敌人',
    targetWeakestDesc: '专注低生命值',
    targetStrongestDesc: '专注高生命值',
    targetRandomDesc: '随机选择目标',
    backToMenu: '返回菜单',
    dieRebirth: '死亡并重生',
    freeRebirth: '免费重生',
    dieConfirmTitle: '死亡并重生？',
    dieConfirmBody: '当前的战斗将结束，你的精通将被应用。是否继续？',
    dieConfirmYes: '死亡并重生',
    battleConfig: '战斗配置',
    masteries: '精通',
    ascentBtnLabel: '升华',
    enemyLevelLabel: '敌人等级',
    pauseLabel: '暂停',
    playLabel: '继续',
    x2SpeedRemaining: '×2速度剩余时间',
    enemyLevelDown: '降低敌人等级',
    enemyLevelUp: '提高敌人等级',
    autoAdvanceTitle: '解锁时自动提升敌人等级',
    autoLevelAriaLabel: '自动提升敌人等级',
    autoLevelText: '自动',
    ascendBtn: '升华到新宇宙',
    masteryGains: '精通收益',
    actionTriggerTitle: '行动触发器',
    selectActionTrigger: '选择行动触发器',
    slotInUse: '已被其他触发器使用',
    triggerTime: '时间触发器',
    triggerTimeDesc: '每2秒触发一次。更快的行动造成更多伤害，更慢的行动造成更少伤害。',
    triggerCrit: '暴击触发器',
    triggerCritDesc: '当自动攻击命中暴击时触发。基础伤害低10倍，以速度平衡。',
    triggerCritLock: '用暴击击杀Boss',
    triggerAffliction: '折磨触发器',
    triggerAfflictionDesc: '每施加10次折磨时触发。伤害以速度平衡。',
    triggerAfflictionLock: '用折磨伤害击杀Boss',
    triggerMana: '法力触发器',
    triggerManaDesc: '你的行动每消耗100点法力时触发。伤害以速度平衡。',
    dpsDoubleAction: '双重行动',
    dpsBonusTarget: '额外目标',
    dpsExtraProjectile: '额外弹射物',
    dpsSplitCast: '分裂施法',
    dpsChainJump: '连锁跳跃',
    dpsTremor: '震颤',
    dpsAfflictionBurn: '燃烧',
    dpsAfflictionBleed: '流血',
    dpsAfflictionGroundFire: '地面火焰',
    dpsAfflictionPoison: '中毒',
    dpsSplash: '溅射',
    dpsTakenHits: '受到伤害（击打）',
    dpsTakenAfflictions: '受到伤害（异常状态）',
    dpsAvgHitTaken: '平均受击伤害',
    dpsMaxHitTaken: '最大单次受击',
    selectAnAction: '选择一个行动',
    critLabel: '暴击',
  },
  mastery: {
    title: '精通',
    resetTitle: '重置 {name}？',
    confirmCancel: '取消',
    confirmReset: '重置',
    resetDescLoseLevel: '所有已分配的节点将被清除，你将在此精通中失去1级。已转换的点数将被退还。',
    resetDescNoLoseLevel: '所有已分配的节点将被清除。免费和已转换的精通点数将被退还。',
    nodeSmall: '小节点',
    nodeStrong: '强节点',
    nodeMajor: '主节点',
    nodeKey: '关键节点',
    nodeAssigned: '已分配',
    nodeAssignPt: '分配（{cost} 点）',
    nodeAssignPts: '分配（{cost} 点）',
    nodeNeedPt: '需要 {cost} 个精通点（你有 {available}）',
    nodeNeedPts: '需要 {cost} 个精通点（你有 {available}）',
    nodeKeyChosen: '已选择另一个关键节点',
    nodeNotImpl: '尚未实现',
    nodeNotAvail: '节点不可用',
    resetBtn: '重置（−1 级）',
    dumpBtn: '转换一点',
    dumpTooltip: '点击：转换1点 · Ctrl/Cmd+点击：转换全部',
    dumpActivePt: '转换：{dumped} 点 → +{bonus}% 更多 {label}',
    dumpActivePts: '转换：{dumped} 点 → +{bonus}% 更多 {label}',
    dumpLabel: '转换点数获得每点 +{rate}% 更多 {label}',
    pointsPt: '你有 {total} / {earned} 个精通点可分配{free}',
    pointsPts: '你有 {total} / {earned} 个精通点可分配{free}',
    pointsFree: '（{n} 免费）',
    ctrlClickHint: '提示：Ctrl/Cmd + 点击节点可一次性分配所有可用点数。',
    savePlan: '保存方案',
    loadPlan: '加载方案',
    assignAll: '全部分配',
    assignAllDump: '倾倒多余点数',
    assignAllDumpTooltip: '完成配置方案后，"全部分配"会将剩余点数倾倒到转换中',
    slot: '槽位 {n}',
    slotEmpty: '（空）',
    copyClipboard: '复制到剪贴板',
    importCode: '导入',
    planActive: '{code}',
    planInvalid: '无效的构建代码',
    assignAllNone: '未加载方案',
    saveNoHistory: '当前节点的分配顺序未被记录。下次升华后即可保存方案。',
    pendingGainsNote: '以绿色显示的进度只有在死亡并重生后才能获得',
  },
  ascent: {
    title: '升华',
    ascentCount: '升华次数：{n}',
    nextAscent: '下次升华：敌人等级 {n}',
    unlockedAt: '解锁于',
    universePoints: '宇宙点数',
    available: '（{n} 可用）',
    removePoint: '移除点数',
    addPoint: '添加点数',
    threshold1: '暴击及其精通',
    threshold2: '敌人精通中的冠军和Boss树',
    threshold3: '+1 行动触发器槽',
    threshold4: '每次升华为每个精通获得 +1 免费精通点',
    threshold5: '神器 — 风险/奖励修改器',
    threshold6: '+1个动作触发槽',
    threshold7: '每次飞升获得3个宇宙点数（而非2个）',
    threshold8: '敌人数量增加20%，敌人等级经验增加20%',
    threshold9: '可装备第二件神器，背包最多可携带30件',
    artifactsBtn: '神器',
    upSlotA: '多重行动速度提升10%',
    upSlotB: '+1% 基础行动暴击率',
    upSlotC: '增加7%伤害',
    upSlotD: '增加4%行动速度',
  },
  transcend: {
    btn: '超越',
    pickerTitle: '选择一件圣遗物',
    pickerHint: '超越将重置一切——包括升华、宇宙点数和未装备的神器。已装备的神器和圣遗物将保留。选择圣遗物以完成超越。',
    confirmTitle: '超越？',
    confirmBody: '一切都将重置——包括升华、宇宙点数和未装备的神器。已装备的神器和圣遗物将保留。',
    relicFreeRebirth: '重生回响',
    relicFreeRebirthDesc: '每次重生一次，无需死亡即可获得未结算的精通进度。',
    relicMultiAscend: '断链者',
    relicMultiAscendDesc: '升华时可一次获得多次升华，上限为你的最高敌人等级−5。',
    relicExtraTrigger: '第三只手',
    relicExtraTriggerDesc: '永久解锁一个额外的行动触发器槽位。',
    relicOnslaught: '猛攻',
    relicOnslaughtDesc: '敌人数量增加30%，全部经验增加10%，全部伤害增加10%。',
    powerLabel: '超越：{n}',
    powerSummary: '+{xp}% 经验 · +{dmg}% 伤害 · +{life}% 最大生命',
    relicsLabel: '圣遗物',
    ascendPlus: '{label}（+{n}）',
  },
  artifacts: {
    title: '神器',
    countLabel: '{n}/{max} 神器',
    equippedLabel: '已装备：{used}/{max}',
    full: '背包已满 — 丢弃一件神器才能从Boss处获得新的',
    equip: '装备',
    unequip: '卸下',
    bag: '背包',
    drop: '丢弃',
    deleteBtn: '删除',
    deleteConfirmTitle: '删除神器？',
    deleteConfirmBody: '此神器将永久失去。',
    deleteConfirmBtn: '删除',
    lockedHint: '装备槽已满 — 请先卸下另一件神器',
    sourceFire: '火焰',
    sourceLightning: '闪电',
    sourcePhysical: '物理',
    sourceCold: '冰冷',
    sourceRot: '腐蚀',
    posSourceMoreDamage: '{v}%更多{source}伤害',
    posSourceActionSpeed: '{v}%提升{source}行动速度',
    posSourceAffliction: '{v}%更多{source}折磨效果',
    posGlobalActionSpeed: '{v}%更多行动速度',
    posGlobalMoreDamage: '{v}%更多伤害',
    posDoubleDamageChance: '+{v}%双倍伤害概率',
    posDoubleActionChance: '+{v}%双倍行动概率',
    posRangeAndArea: '+{v}%范围和区域',
    negDamageTaken: '{v}%更多受到伤害',
    negAllResistances: '-{v}%全部抗性',
    negLessMoveSpeed: '-{v}%移动速度',
    negLessActionSpeed: '-{v}%行动速度',
    negLessRangeAndArea: '-{v}%范围和区域',
    weightLight: '轻型神器',
    weightMedium: '中型神器',
    weightHeavy: '重型神器',
    scrapsLabel: '碎片：{n}',
    upgradeBtn: '升级 {scraps}/{cost}',
    upgradeResultTitle: '神器已升级',
    upgradeMaxedTitle: '已满级',
    upgradeMaxedBody: '该神器的所有词条均已达到上限，无法继续升级。',
    upgradeRemovedLabel: '已移除负面词条：',
    autoDiscardLabel: '按品质自动丢弃神器：',
    autoDiscardNever: '从不丢弃',
    autoDiscardAll: '全部丢弃',
    autoDiscardBelow: '<{v}%',
    autoDiscardDown: '降低自动丢弃品质阈值',
    autoDiscardUp: '提高自动丢弃品质阈值',
    autoDiscardWeightLabel: '或重量：',
    autoDiscardWeightAll: '保留所有尺寸',
    autoDiscardWeightLight: '丢弃轻型',
    autoDiscardWeightMedium: '丢弃中型及以下',
    autoDiscardWeightDown: '降低自动丢弃重量阈值',
    autoDiscardWeightUp: '提高自动丢弃重量阈值',
  },
  rune: {
    addToSlot: '将 {type} 符文添加到第 {n} 槽',
    clickToChange: '{label} — 点击更改',
    addRune: '+ 添加符文',
    remove: '移除"{label}"',
    runesTitle: '{action} 符文',
    runesAriaLabel: '符文',
    slotMinor: '次要',
    slotMajor: '主要',
    slotKey: '关键',
    slotSource: '来源',
    levelHint: '行动等级 {level} — {unlocked}/7 槽已解锁 — +{bonus}% 经验',
    selectTitle: '{type} 符文 — 第 {n} 槽',
  },
  menu: {
    continue: '继续',
    characters: '角色',
    about: '关于',
    nav: '主菜单',
  },
  about: {
    title: '关于 Path of Praxis',
    body: '由Aractis制作的放置自动战斗游戏，灵感来自动作RPG、多层声望放置游戏和基于使用的奖励系统。这款早期（测试版）游戏旨在提供丰富的理论研究体验，具有半放置游戏的机制。请在选项中链接的Discord中提供任何报告、反馈或请求。务必查看下面的TODO！',
    creditsTitle: '致谢',
    creditsAlpha: '感谢N4pkin的鼓励和内测。',
    creditsKenneyUi: 'UI面板和按钮：**Kenney RPG UI Pack Extension**（CC0）。',
    creditsKenneyDungeon: '地图瓦片和障碍物：**Kenney Tiny Dungeon**（CC0）。',
    creditsLucide: '图标：**Lucide**（ISC许可证）。',
    creditsFonts: '字体：**Cinzel** 和 **Crimson Pro**，来自Google Fonts（SIL OFL）。',
    creditsClaude: '使用**Claude**（Anthropic）辅助开发。',
    releaseNotes: '版本说明',
    releaseNotesTitle: '版本说明',
    todo: '待办事项',
    todoTitle: '待办事项',
    privacy: '隐私',
    privacyTitle: '隐私政策',
    eula: '用户协议',
    eulaTitle: '最终用户许可协议',
  },
  terms: {
    title: '游戏前',
    intro: '请阅读并接受这两份文件以继续。',
    privacyLabel: '我已阅读并接受{link}。',
    eulaLabel: '我已阅读并接受{link}。',
    privacyLink: '隐私政策',
    eulaLink: '最终用户许可协议',
    privacyTitle: '隐私政策',
    eulaTitle: '最终用户许可协议',
    continue: '继续',
  },
  character: {
    newTitle: '新角色',
    loadTitle: '加载角色',
    nameLabel: '名称',
    namePlaceholder: '输入名称…',
    create: '创建',
    cancel: '取消',
    current: '当前',
    emptySlot: '— 空 —',
    newSlot: '新建',
    deleteLabel: '删除',
    nameTaken: '该名称已被使用。',
    infoTitle: '角色',
    statMaxLife: '最大生命值',
    statMaxMana: '最大法力值',
  },
  settings: {
    title: '设置',
    language: '语言',
    languageTitle: '语言',
    hotkeysTitle: '快捷键',
    langEn: 'English',
    langFr: 'Français',
    langEs: 'Español',
    langZh: '简体中文',
    langRu: 'Русский',
    close: '关闭',
    guide: '指南',
    discord: 'Discord',
    soundVolume: '音效音量',
    soundMuted: '静音',
    effectOpacity: '特效不透明度',
    effectDetail: '特效渲染',
    showDamageNumbers: '显示伤害数字',
    showDpsMeter: 'DPS 计量器',
    fullMastery: '完整精通',
    zoomLabel: '缩放',
    fullscreen: '全屏',
    confirmDeath: '手动死亡前确认',
    resetTutorials: '重置教程',
    saveData: '存档数据',
    saveDataDesc: '复制你的存档代码以备份或转移到另一设备，或粘贴代码以恢复。导入将替换所有当前角色。',
    exportSave: '复制存档代码',
    exportCopied: '已复制！',
    importLabel: '粘贴存档代码',
    importPlaceholder: '在此粘贴你的存档代码…',
    importBtn: '导入',
    importError: '无效的存档代码',
    importConfirmTitle: '替换所有角色？',
    importConfirmBody: '导入将永久替换所有现有角色的存档数据。此操作无法撤销。',
    importConfirmBtn: '替换',
    cancel: '取消',
  },
  guide: {
    title: '指南',
    comingSoon: '敬请期待…',
  },
  tutorial: {
    dismiss:  '忽略',
    next:     '下一步',
    done:     '完成',
    moreInfo: '更多信息 →',
    dontShow: '不显示教程',
  },
  awayBonus: {
    title:   '欢迎回来！',
    body:    '你离开了 {away}，获得了 {earned} 的 ×2 速度时间。',
    close:   '关闭',
    watchAd: '观看广告 — 双倍奖励',
    continue: '继续',
  },
  refillAd: {
    title:   '储备耗尽',
    body:    '你的 ×2 速度储备刚刚耗尽。观看简短广告以获得15分钟。',
    watchAd: '观看广告 — 获得15分钟',
    skip:    '不，谢谢',
    refill:  '补充',
  },
  masteryCategory: {
    action: '行动',
    damageBase: '基础伤害',
    damageType: '伤害类型',
    lifeMana: '生命与法力',
    world: '世界',
  },
  masteryLabel: {
    action: '行动',
    criticalHit: '暴击',
    physical: '物理',
    fire: '火焰',
    lightning: '闪电',
    cold: '冰',
    rot: '腐烂',
    area: '区域',
    projectile: '弹射物',
    strike: '打击',
    life: '生命',
    mana: '法力',
    block: '格挡',
    enemy: '敌人',
    movement: '移动',
  },
  masteryTree: {
    action_0: '行动伤害', action_1: '行动速度', action_2: '恍惚', action_3: '法力消耗',
    criticalHit_0: '暴击伤害', criticalHit_1: '暴击率',
    physical_0: '物理伤害', physical_1: '流血', physical_2: '破甲', physical_3: '嗜血',
    fire_0: '火焰伤害', fire_1: '燃烧', fire_2: '燃烧地面', fire_3: '献祭',
    lightning_0: '闪电伤害', lightning_1: '电击', lightning_2: '跳跃', lightning_3: '充电',
    cold_0: '冰冷伤害', cold_1: '霜冻', cold_2: '破碎', cold_3: '冰甲',
    rot_0: '腐烂伤害', rot_1: '中毒', rot_2: '削弱', rot_3: '绿脉',
    area_0: '区域伤害', area_1: '区域大小', area_2: '震颤', area_3: '击退',
    projectile_0: '弹射物伤害', projectile_1: '多重弹射物', projectile_2: '弹射物射程', projectile_3: '击退',
    strike_0: '打击伤害', strike_1: '狂怒', strike_2: '打击范围', strike_3: '额外目标',
    life_0: '最大生命值', life_1: '抗性', life_2: '生命恢复', life_3: '生命偷取',
    mana_0: '最大法力值', mana_1: '法力护盾', mana_2: '法力恢复', mana_3: '法力偷取',
    block_0: '格挡几率', block_1: '格挡效率',
    enemy_0: '敌人数量', enemy_1: '敌人质量', enemy_2: '冠军和Boss', enemy_3: '敌人扩散',
    movement_0: '移动速度', movement_1: '冲刺', movement_2: '风筝战术',
  },
  masteryDump: {
    action: '行动伤害', criticalHit: '暴击伤害', physical: '物理伤害',
    fire: '火焰伤害', lightning: '闪电伤害', cold: '冰冷伤害', rot: '腐烂伤害', area: '区域行动范围',
    projectile: '弹射物射程', strike: '打击行动速度', life: '最大生命值',
    mana: '最大法力值', enemy: '生成的敌人', movement: '移动速度',
    block: '格挡几率',
  },
  runeLabel: {
    minorDmg: '伤害', minorSpeed: '速度', minorMana: '法力', minorXp: '经验', minorAll: '综合',
    majorDmg: '伤害', majorSpeed: '速度', majorMana: '法力', majorXp: '经验', majorAll: '综合',
    keySplit: '分裂行动', keyHeavy: '慢而重', keyManaless: '无法力', keyConsequences: '后果',
    sourceCold: '冰箱开着', sourceFire: '炉子开着', sourceLightning: '灭虫灯插着', sourcePhysical: '钉子撒了', sourceRot: '袜子乱丢',
  },
  runeDesc: {
    minorDmg: '+15% 提升行动伤害',
    minorSpeed: '+5% 提升行动速度',
    minorMana: '−10% 行动法力消耗',
    minorXp: '+20% 提升行动经验',
    minorAll: '+3.75% 伤害 / +1.25% 速度 / −2.5% 法力消耗 / +5% 经验',
    majorDmg: '10% 更多行动伤害',
    majorSpeed: '5% 更多行动速度',
    majorMana: '20% 更少行动法力消耗',
    majorXp: '15% 更多行动经验',
    majorAll: '2.5% 更多伤害 / 1.25% 更多速度 / 5% 更少法力 / 3.75% 更多经验',
    keySplit: '×2 行动速度 — 行动伤害降低 33%',
    keyHeavy: '×2 行动伤害 — 行动速度降低 33%',
    keyManaless: '×2 法力消耗 — 即使法力不足也会触发行动',
    keyConsequences: '该行动的异常状态伤害 ×2（对不造成伤害的异常状态无效）',
    sourceCold: '20% 的击打视为冰冷伤害而非行动原本的伤害来源——应用冰冷精通的效果与经验',
    sourceFire: '20% 的击打视为火焰伤害而非行动原本的伤害来源——应用火焰精通的效果与经验',
    sourceLightning: '20% 的击打视为闪电伤害而非行动原本的伤害来源——应用闪电精通的效果与经验',
    sourcePhysical: '20% 的击打视为物理伤害而非行动原本的伤害来源——应用物理精通的效果与经验',
    sourceRot: '20% 的击打视为腐蚀伤害而非行动原本的伤害来源——应用腐蚀精通的效果与经验',
  },
  actionLabel: {
    sword: '剑击', bow: '狙击箭', fireball: '火球', zap: '电击',
    'fire-nova': '火焰新星', grenade: '手榴弹', 'hammer-slam': '锤击',
    'lightning-nova': '闪电新星', bolt: '闪电箭', 'cold-nova': '冰霜新星', 'ice-spear': '寒冰长矛',
    'putrid-nova': '腐烂新星',
    'rotten-dagger': '腐烂匕首',
    'poisonous-arrow': '毒箭',
  },
  actionTag: {
    physical: '物理', fire: '火焰', lightning: '闪电', cold: '寒冷', rot: '腐烂',
    strike: '打击', projectile: '弹射物', area: '区域',
  },
}
